import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { MenuItem } from "reakit";

import { NavItem } from "../Topbar/components/NavItem";

type Props = {
  variant?: "text" | "mobile";
};

export const HelpCenter: FC<Props> = ({ variant = "text" }) => {
  const { t } = useTranslation("session");
  const helpCenterRoute = t(`public:LINKS.HELP-CENTER`);

  return (
    <MenuItem
      as={NavItem}
      onClick={() => window.open(helpCenterRoute, "_blank")}
      variant={variant}
      text={t("COMPONENTS.TOPBAR.BUTTON_HELP_CENTER")}
    />
  );
};
